import { View } from "ui/atoms/view";
import { MedicationItemSummary } from "../atoms/MedicationItemSummary";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { Text } from "react-native";
import { MedicationFormIcon } from "../atoms/MedicationFormIcon";

interface Props {
  medication: MedicationModel;
}

export function MedicationItemBanner({ medication }: Props) {
  return (
    <View className="flex sm:flex-row flex-wrap py-5 px-7 rounded-xl border border-border-200 w-full gap-x-6">
      <View className="flex-row items-center gap-4">
        <MedicationFormIcon type={medication.form} />
        <Text className="font-semibold text-typography-900 line-clamp-3">
          {medication.name}
        </Text>
      </View>
      <MedicationItemSummary medication={medication} className="mt-5 w-full" />
    </View>
  );
}
